import React from 'react';
import PageMeta from '../../components/PageMeta';
import { Modal } from '@redq/reuse-modal';
import withLayout from '../../hoc/withLayout';
import { useTranslation } from 'next-i18next';
import ProfilePage from '../../containers/Profile';
import withPrivate        from "../../hoc/withPrivate";
import simplePage         from "../../serverProps/simplePage";

const Tabs = props => {
  const { t } = useTranslation();

  return (
    <>
      <PageMeta
        title={t(`${process.env.APP_LOCALIZATION}:profile.head.title`)}
        description={t(
          `${process.env.APP_LOCALIZATION}:profile.head.description`
        )}
      />
      <ProfilePage {...props} />
      <Modal />
    </>
  );
};

export default withPrivate(withLayout(Tabs));

export const getServerSideProps = simplePage;
